export default "__VITE_ASSET__B5Lde6$P__"